import { RouteObject } from 'react-router-dom';

import LogisticsNetwork from '../LogisticsNetwork';

export const LogisticsNetworkRoutes: RouteObject[] = [
  {
    path: 'logistics-network',
    element: <LogisticsNetwork />,
  },
];
